var map = {
	"./js0/1.png": "daec",
	"./js1/1.png": "5a1b",
	"./js2/1.png": "d4a8",
	"./js3/1.png": "37d3",
	"./js4/1.png": "88ca",
	"./js5/1.png": "133e",
	"./js6/1.png": "5154"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8153";